export default __webpack_public_path__ + "static/media/companyLogo.99bee472.png";